import Head from 'next/head';

interface IOpengraphTagProps {
  og_title: string;
  og_image: string;
  og_url: string;
  error: unknown;
}
function OpengraphTag({
  og_url,
  og_title,
  og_image,
  error,
}: IOpengraphTagProps) {
  if (error) console.error(error);

  return (
    <Head>
      <meta property="og:url" content={og_url} key="og:url" />
      <meta property="og:title" content={og_title} key="og:title" />
      <meta property="og:image" content={og_image} key="og:image" />
      <meta property="og:description" content="" key="og:description" />
    </Head>
  );
}

export default OpengraphTag;
